// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"279":"ab5f8000","422":"37435044","533":"82d0cf65","648":"a076ed5f","973":"fea65eed"}[chunkId] + ".chunk.js";
};